<template>
    <div>
        <v-card>
            <v-card-title>
                <span class="headline">Proveedores</span>
            </v-card-title>

            <v-card-text>
                <v-data-table :headers="headers" :items="allSuppliers" :search="search">
                    <template v-slot:top>
                        <v-toolbar color="white">
                            <v-text-field v-model="search" prepend-icon="fa-search" label="Buscar..." clearable single-line
                                hide-details></v-text-field>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom v-if="can('consumables.supplier-admin')">
                                <template v-slot:activator="{ on: tooltip }">
                                    <v-btn v-on="{ ...tooltip }" small color="primary" class="mx-2 my-2" fab dark
                                        @click.stop="$event => $refs.formSupplier_.newItem()">

                                        <v-icon>fa-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Nuevo</span>
                            </v-tooltip>

                            <v-menu offset-y>
                                <template v-slot:activator="{ on: menu }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on: tooltip }">
                                            <v-btn class="mx-2" icon color="primary" v-on="{ ...tooltip, ...menu }"
                                                id="newLoan">
                                                <v-icon dark>fa-ellipsis-v</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Mas...</span>
                                    </v-tooltip>

                                </template>
                                <v-list dense flat>
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn class="mx-2" icon color="primary" v-on="{ ...tooltip, ...menu }"
                                                    id="newLoan">
                                                    <v-icon dark>fa-ellipsis-v</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Mas...</span>
                                        </v-tooltip>
                                    </template>
                                    <v-list-item-group>
                                        <v-list-item @click="$refs.importSupplier_.open()"
                                            v-if="can('consumables.supplier-admin')">
                                            <v-list-item-icon>
                                                <v-icon color="light-blue darken-3">fa-file-upload</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Importar Proveedores</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item @click="exportSupplier()" v-if="can('consumables.supplier-list')">
                                            <v-list-item-icon>
                                                <v-icon color="green darken-3">fa-file-download</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>Exportar Proveedores</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                    </v-list-item-group>
                                </v-list>
                            </v-menu>
                        </v-toolbar>
                    </template>

                    <!-- Boton de acciones  -->

                    <template v-slot:item.actions="{ item }">

                        <v-tooltip left v-if="can('consumables.supplier-admin') && item.active">
                            <template v-slot:activator="{ on: tooltip }">
                                <v-icon v-on="{ ...tooltip }" class="mr-2"
                                    @click="$event => $refs.formSupplier_.editItem(item)" color="orange">
                                    fa-pen
                                </v-icon>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>

                        <v-tooltip right v-if="can('consumables.supplier-admin') && item.active">
                            <template v-slot:activator="{ on: tooltip }">
                                <v-icon v-on="{ ...tooltip }" class="mr-2" @click="deleteItem(item.id)" color="red">
                                    fa-trash
                                </v-icon>
                            </template>
                            <span>Eliminar</span>
                        </v-tooltip>

                        <v-tooltip right v-else>
                            <template v-slot:activator="{ on: tooltip }">
                                <v-icon v-on="{ ...tooltip }" class="mr-2" @click="activeItem(item.id)" color="green">
                                    fa-toggle-on
                                </v-icon>
                            </template>
                            <span>Activar</span>
                        </v-tooltip>
                    </template>
                    <!-- fin de boton de acciones  -->
                </v-data-table>
            </v-card-text>
        </v-card>
        <FormSupplier ref="formSupplier_" @initialize="initialize" />
        <ImportSupplier ref="importSupplier_" @initialize="initialize" />
    </div>
</template>

<script>
import FormSupplier from './FormSuppliers.vue';
import ImportSupplier from './ImportSuppliers.vue';
import { mapActions, mapGetters } from 'vuex';
import { can, createLinkFile } from '../../../util/functions';
import { URL_APP } from '../../../util/constants';
export default {
    name: 'consumables_suppliers',
    components: {
        FormSupplier, ImportSupplier
    },
    data: () => {
        return {
            search: '',
            headers: [
                {
                    text: 'Nombre',
                    align: 'start',
                    value: 'name',
                },
                { text: 'NIT', value: 'nit' },
                { text: 'Responsable', value: 'responsible' },
                { text: 'Teléfono', value: 'phone' },
                { text: 'Correo electrónico', value: 'email' },
                { text: 'Acciones', value: 'actions' },
            ],
        }
    },

    mounted() {
        this.initialize()
    },

    computed: {
        ...mapGetters(['loading', 'allSuppliers']),
        currentuser() {
            return this.$store.getters.currentuser
        },
    },

    methods: {
        ...mapActions(['getSuppliers', 'deleteSupplier', 'chgLoad']),
        can: can,

        async initialize() {
            this.chgLoad(true);
            await this.getSuppliers();
            this.chgLoad(false);
        },

        deleteItem(item) {
            this.$swal({
                title: 'Confirmación',
                text: "¿Desea eliminar el proveedor?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, deseo eliminar',
                cancelButtonText: 'Cancelar'
            })
                .then(async (res) => {
                    if (res.isConfirmed) {
                        this.chgLoad(true)
                        try {
                            var msg = await this.deleteSupplier(item)
                            this.initialize()
                            await this.chgLoad(false)
                            await this.$swal(
                                {
                                    title: 'Confirmación',
                                    text: msg.message,
                                    icon: 'success',
                                    timer: 2000
                                }
                            )
                        }
                        catch (err) {
                            this.chgLoad(false)
                            await this.$swal(
                                {
                                    title: 'Error!',
                                    text: 'La marca no se ha eliminado.',
                                    icon: 'error',
                                    timer: 2000
                                }
                            )
                        }

                    }
                })
        },

        activeItem(item) {
            this.$swal({
                title: 'Confirmación',
                text: "¿Desea activar el proveedor?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, deseo activar',
                cancelButtonText: 'Cancelar'
            })
                .then(async (res) => {
                    if (res.isConfirmed) {
                        this.chgLoad(true)
                        try {
                            var msg = await this.deleteSupplier(item)
                            this.initialize()
                            await this.chgLoad(false)
                            await this.$swal(
                                {
                                    title: 'Confirmación!',
                                    text: msg.message,
                                    icon: 'success',
                                    timer: 2000
                                }
                            )

                        }
                        catch (err) {
                            await this.chgLoad(false)
                            await this.$swal(
                                {
                                    title: 'Error!',
                                    text: 'El proveedor no se ha activado.',
                                    icon: 'error',
                                    timer: 2000
                                }
                            )
                        }



                    }
                })
        },

        async exportSupplier() {
            var url = URL_APP + "/api/loan_consumables/export_suppliers";
            this.chgLoad(true);
            await this.$http.get(url, { responseType: 'blob' })
                .then((response) => {
                    createLinkFile(response)
                    this.$root.$alert({ text: "Descarga exitosa", color: "success", timeout: 2000 })
                    this.chgLoad(false);
                })
                .catch(() => {
                    this.$root.$alert({ text: "Error al Obtener el Excel", color: "error", timeout: 2000 })
                    this.chgLoad(false);
                })
        },
    }
}
</script>

<style lang="scss" scoped></style>